import React from "react";
import Clock from "./Clock";

interface HeaderProps {
  title?: string;
  right?: React.ReactNode;
  dbLive?: boolean;
}

const Header: React.FC<HeaderProps> = ({ title = "Data Assets Intelligence", right = null, dbLive }) => {
  return (
    <header>
      <div className="header-left">
        <h1>{title}</h1>
      </div>
      <div className="header-right">
        {dbLive !== undefined && (
          <div
            className="db-status"
            title={dbLive ? "Connected to live Azure SQL Server (cgfpepwisedevDB)" : "Live Azure SQL Server connection unavailable — showing last cached data from cgfpepwisedevDB"}
          >
            <span className={`db-status-dot ${dbLive ? "live" : ""}`}></span>
            <span className="db-status-label">{dbLive ? "Live" : "Static"}</span>
          </div>
        )}
        {right}
        <Clock />
      </div>
    </header>
  );
};

export default Header;
